export enum CardType {
  Vacation = 1,
  Meal = 2,
  Gift = 3,
  Culture = 4,
  Blue = 5,
}

export enum CardTransactionType {
  Purchase = 10,
  PurchaseReversal = 11,
  Refund = 20,
  RefundReversal = 21,
}

export enum FilterTypes {
  TaxationLevel = 1,
  ShowDiscountedProducts = 2,
  AvailableIn = 3,
  Brand = 4,
  PriceRange = 5,
  BuyerType = 6,
  Category = 7,
  EmployerTaxationLevel = 8,
}

export enum SortingOrderTypes {
  TheMostRelevant = 0,
  TheMostPopular = 1,
  TheLowestPrice = 2,
  TheHighestPrice = 3,
  BiggestDiscount = 4,
  LastAdded = 5,
}

export enum RecurrencePeriodType {
  Month = 1,
  Day = 2,
}

export enum OrderStatuses {
  Pending = 1,
  Processing = 2,
  DoubleOrder = 3,
  Complete = 5,
  Canceled = 7,
  Denied = 8,
  CanceledReversal = 9,
  Failed = 10,
  Refunded = 11,
  Reversed = 12,
  Chargeback = 13,
  Expired = 14,
  Processed = 15,
  Voided = 16,
  Paid = 18,
  Waiting = 19,
}

export enum BarcodeTypes {
  Alphanumeric = 0,
  QR = 1,
  Code39 = 39,
  Code128 = 128,
}

export enum BudgetTypes {
  None = 0,
  BenefitBudgetOnly = 1,
  BenefitAndCoPaymentIfNeeded = 2,
  BenefitAndCoPayment = 3,
  CoPaymentOnly = 4,
}

export enum ProductTypes {
  DefaultProduct = 0,
  CashBack = 1,
  FreePdfVoucher = 2,
  FreeLinkVoucher = 3,
  ContactVoucher = 4,
}

export enum TopLevelCategories {
  FlexibleBenefits = 116,
  FixedBenefits = 846,
  BenefitClub = 111,
  Cashback = 7054,
  DiscountVouchers = 6795,
}

export enum RedirectCategoryTypes {
  Other = 0,
  Flexible = 1,
  Club = 2,
}

export enum GiftCardBeneficiaryType {
  Employee = 1,
  Dependent = 2,
}

export enum CardFormFactor {
  Plastic = 1,
  Virtual = 2,
}

export enum FormFactorOptionType {
  OnlyPlastic = 1,
  OnlyVirtual = 2,
  PlasticAndVirtual = 3,
  PlasticAndVirtualFirstOrder = 4,
}

export enum FormFactorSelectorContext {
  Buy = 1,
  Reissue = 2,
}

export enum HelpMediaType {
  Image = 1,
  Video = 2,
  File = 3,
}

export enum SmartNotificationRepeatTypes {
  Always = 0,
  Session = 1,
  OnceEveryNDays = 2,
}

export enum BenefitType {
  Flexible = 0,
  Club = 1,
  Cashback = 2,
  DiscountVouchers = 3,
}

export enum TagType {
  BeneficiaryType = 5,
  ProductType = 6,
  UseInType = 7,
  DisponibilityNowType = 9,
  DisponibilityNextMonthType = 10,
}

export enum CheckOutWarningType {
  NoPaymentMethodSelected = 0,
  NotEnoughBenefitBucks = 1,
  PlatformIsClosed = 2,
  NoTemporaryDeactivated = 3,
}

export enum TimesheetPresenceTypeCategories {
  Other = 0,
  Work = 1,
  Vacation = 2,
}

export enum BuyerTypes {
  Employee = 1,
  Dependent = 2,
}

export enum ContestStatuses {
  CustomerNotRegistered = 1,
  CustomerRegistered = 2,
  PendingForWinners = 3,
  WinnersSelected = 4,
}

export enum DiscoverCardTypes {
  Cashback = 7054,
  DiscountVouchers = 6795,
}

export enum DiscoverCategoryTypes {
  BenefitsUnder50 = 1,
  BenefitsUnder200 = 2,
  CashbackWithBenefitBucks = 3,
  TaxUnder10 = 4,
}

export enum VoucherCodeTypes {
  SoCode = 1,
  Emag = 2,
  BuyBoxCode = 3,
  VoucherDescription = 4,
  RandomGenerated = 5,
  SarkkromVoucher = 6,
}

export enum PlatformBenefitTypes {
  FlexibleBenefits = 1,
  SpecialOffers = 2,
  Encentive = 3,
}

export enum RevolutionSliderTypes {
  HomeSlideshow = 5,
  FlexibleBenefitsSlideshow = 6,
  BenefitClubSlideshow = 7,
}

export enum PresenceTypeCategories {
  Work = 1,
  Vacantion = 2,
}

export enum EmployeeCardStatuses {
  Active = 1,
  PendingIssue = 2,
}

export enum DependentsCustomType {
  CheckboxList = 1,
  RadioButtonList = 2,
}

export enum DyPageTypeEnum {
  Homepage = 0,
  Category = 1,
  Product = 2,
  Cart = 3,
  Other = 4,
}

export enum DyEngagementTypes {
  SlotClick = 1,
  Click = 2,
  Imp = 3,
}

export enum CustomClientTypes {
  Default = 0,
  HpeCustom = 1,
}

export enum OptInChannelTypes {
  None = 0,
  Email = 1,
  Sms = 2,
  PushNotification = 3,
}

export enum OptInSourceTypes {
  NotTracked = 0,
  Admin = 1,
  Email = 2,
  RegisterAccount = 3,
  HomePage = 4,
  PaymentConfirmation = 5,
  PopupMyAccount = 6,
  CommunicationPreferences = 7,
  BabyAdmin = 8,
}

export enum OptInStateTypes {
  Rejected = 0,
  Accepted = 1,
}

export enum OptInTypes {
  TCPP = 1,
  NewsletterLegal = 2,
  NewsletterMarketing = 3,
  DynamicYield = 4,
  AvailabilityNotification = 5,
}
